import { render, staticRenderFns } from "./detentionEdit.vue?vue&type=template&id=ee5b1234"
import script from "./detentionEdit.vue?vue&type=script&lang=js"
export * from "./detentionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports